import type { ReactNode } from "react";

import { useCanExport } from "./useCanExport";

/** Renders children only for whoever may import and export, else `fallback`. */
export const CanExport = ({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) => {
  const { canExport, isPending } = useCanExport();
  if (isPending) return null;
  return canExport ? children : fallback;
};
